import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from '../hooks/useTranslation'
import SEO from '../components/SEO'
import Layout from '../components/Layout'

export default function NotFoundPage() {
  const { t, currentLanguage } = useTranslation()

  return (
    <Layout>
      <SEO
        title={currentLanguage === 'ar' ? '404 — الصفحة غير موجودة | badanibex' : '404 — Page Not Found | badanibex'}
        description={currentLanguage === 'ar' ? 'الصفحة التي تبحث عنها غير موجودة.' : 'The page you are looking for does not exist.'}
        noindex={true}
        nofollow={true}
      />

      <div
        className="min-h-[80vh] flex flex-col items-center justify-center text-center px-4"
        style={{ color: 'var(--text)' }}
      >
        {/* رقم الخطأ */}
        <div
          className="text-[120px] sm:text-[160px] font-black leading-none select-none"
          style={{
            color: 'transparent',
            WebkitTextStroke: '2px var(--gold)',
            opacity: 0.25,
          }}
        >
          404
        </div>

        {/* العنوان */}
        <h1
          className="text-2xl sm:text-3xl font-bold mt-[-20px] mb-4"
          style={{ color: 'var(--text)' }}
        >
          {currentLanguage === 'ar' ? 'الصفحة غير موجودة' : 'Page Not Found'}
        </h1>

        {/* الوصف */}
        <p
          className="max-w-md text-base mb-8"
          style={{ color: 'var(--text-muted, #7a8599)' }}
        >
          {currentLanguage === 'ar'
            ? 'يبدو أن هذه الصفحة لا وجود لها أو تم نقلها.'
            : 'This page does not exist or may have been moved.'}
        </p>

        {/* أزرار */}
        <div className="flex flex-wrap gap-3 justify-center">
          <Link
            to="/"
            className="px-6 py-3 rounded-lg font-semibold text-sm transition-opacity hover:opacity-80"
            style={{ background: 'var(--gold)', color: '#0d0f14' }}
          >
            {currentLanguage === 'ar' ? 'العودة للرئيسية' : 'Back to Home'}
          </Link>
          <Link
            to="/catalog"
            className="px-6 py-3 rounded-lg font-semibold text-sm transition-opacity hover:opacity-80"
            style={{ background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)' }}
          >
            {currentLanguage === 'ar' ? 'تصفح المنتجات' : 'Browse Products'}
          </Link>
        </div>
      </div>
    </Layout>
  )
}
